<template>
  <div
    v-if="(!lazy || loaded) || active"
    v-show="active"
    :id="`pane-${panelName}`"
    :aria-hidden="!active"
    :aria-labelledby="`tab-${panelName}`"
    class="s-tab-pane"
    role="tabpanel">
    <slot/>
  </div>
</template>
<script>
export default {
  name: 'sTabPanel',
  data() {
    return {
      index: null,
      loaded: false
    }
  },
  componentName: 'sTabPanel',
  props: {
    label: String,
    labelContent: Function,
    name: [String, Number],
    closable: Boolean,
    disabled: Boolean,
    lazy: Boolean
  },
  computed: {
    isClosable() {
      return this.closable || this.$parent.closable
    },
    active() {
      const active = ('' + this.$parent.currentName) === this.panelName
      if (active) {
        this.loaded = true
      }
      return active
    },
    panelName() {
      return '' + (this.name || this.index)
    }
  },

  updated() {
    this.$parent.$emit('tab-nav-update')
  }
}
</script>